export default [2, 2, 1];